import React from "react";
import { useDisclosure } from "@mantine/hooks";
const reducer = (state, action) => {
  const { fieldName, payload, type } = action;
  if (type === "RESET") return {};
  if (typeof fieldName === "string") {
    const keys = fieldName.split(".");
    return produceNewState(state, keys, payload);
  }
  return { ...state, [fieldName]: payload };
};
const produceNewState = (obj, keys, value) => {
  if (!keys.length) return value;
  const [first, ...rest] = keys;
  const current = obj && typeof obj === "object" ? obj : {};
  const clone = Array.isArray(current) ? [...current] : { ...current };
  clone[first] = rest.length
    ? produceNewState(clone[first], rest, value)
    : value;

  return clone;
};
const LayoutContext = React.createContext(undefined);
export const useLayout = () => React.useContext(LayoutContext);
export const LayoutProvider = ({ children }) => {
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const initState = {
    header: {
      height: { base: 45, sm: 40, lg: 50 },
    },
  };
  const [options, dispatchOptions] = React.useReducer(reducer, initState);
  return (
    <LayoutContext.Provider
      value={{
        mobileOpened,
        desktopOpened,
        toggleDesktop,
        toggleMobile,
        options,
        dispatchOptions,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
